let CienciaEmCasa = [
  {
    title: "Da Engenharia Mecatrônica à carreira de desenvolvedor de jogos no Canadá ",
    instructor: "Lavio Fidélis",
    /*institution: "xx",
    date: "10/04",
    time: '21:00',
    place: 'Online',
    link:"https://teams.microsoft.com/l/meetup-join/19%3adcb5856375ad4247a353459a1d1f6306%40thread.tacv2/1712770197534?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%227de682ee-0988-4ec1-ac3f-7069dc850ab2%22%7d"
   },
  {
    title: "Trajetórias pelo Design - Egresso João Tiago Camargo ",
    instructor: "João Tiago Camargo",
    /*institution: "xx",
    desc: `xx`,*/
    desc: `Trajetória de egresso da PUC do curso de Engenharia de Controle e Automação até mudança e trabalho na Ubisoft do Canadá.	`,
    certificado: "https://sites.pucgoias.edu.br/certificados/participantes/2925",
    date: "10/04",
    time: '21:00',
    place: 'Online',
    link:"https://teams.microsoft.com/l/meetup-join/19%3adcb5856375ad4247a353459a1d1f6306%40thread.tacv2/1712770197534?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%227de682ee-0988-4ec1-ac3f-7069dc850ab2%22%7d"
   },

   {
    title: "Trajetórias em Design - Egresso Ricardo Queiroz",
    instructor: "Ricardo Queiroz",
    /*institution: "xx",
    desc: `xx`,*/
    certificado: "https://sites.pucgoias.edu.br/certificados/participantes/2905",
    date: "18/04",
    time: '10:30',
    place: 'Online',
    link:"https://www.youtube.com/watch?v=UUlrAXK6Ltk"

   },

   {
    title: "Startups e ideias disruptivas",
    instructor: "Everaldo Lopes dos Santos",
    /*institution: "xx",
    desc: `xx`,*/
    certificado: "https://sites.pucgoias.edu.br/certificados/participantes/2870",
    date: "16/04",
    time: '19:00',
    place: 'Online',
    link:"https://www.youtube.com/watch?v=ReVSnabmLEs"

   },

   {
    title: "Inteligência Artificial aplicada nas Pesquisas Científicas",
    instructor: "Lucas de Suza Rodrigues",
    /*institution: "xx",
    desc: `xx`,*/
    certificado: "https://sites.pucgoias.edu.br/certificados/participantes/2810",
    date: "11/04",
    time: '08:30',
    place: 'Online',
    link:"https://www.youtube.com/watch?v=ntECqnRu57k"

   },

   {
    title: "Potencialidades do Design",
    instructor: "Fernando Felipe",
    /*institution: "xx",
    desc: `xx`,*/
    certificado: "https://sites.pucgoias.edu.br/certificados/participantes/2902",
    date: "17/04",
    time: '19:30',
    place: 'Online',
    link:"https://www.youtube.com/watch?v=tJXqGMl_iG4"
   },

   {
    title: "Design inclusivo, exclusivo e ancestral ",
    instructor: "Ester Carro",
    /*institution: "xx",*/
    desc: `Ester Carro vem falar sobre o Fazendinhando, que é um instituto de transformação territorial, cultural e socioambiental que atua em favelas, feito por e para os moradores. 
    Esta palestra será transmitida ao vivo no Auditório 1, área II.`,
    date: "19/04",
    time: '10:30',
    place: 'Online',
    link:"https://www.youtube.com/watch?v=pZjeisIMHZM"
   },

   {
    title: "Como se Planejar para uma Carreira de TI Internacional",
    instructor: "Juliana Moreira Barbosa",
    /*institution: "xx",
    desc: `xx`,*/
    certificado: "https://sites.pucgoias.edu.br/certificados/participantes/2865",
    date: "16/04",
    time: '20:30',
    place: 'Online',
    link:"https://www.youtube.com/watch?v=j3m3TJS83d8"
   },

   {
    title: "Creator Economy, olhando para o futuro do empreendedorismo digital",
    instructor: "Adriane Maia Insuela",
    /*institution: "xx",
    desc: `xx`,*/
    certificado: "https://sites.pucgoias.edu.br/certificados/participantes/2889",
    date: "18/04",
    time: '19:00',
    place: 'Online',
    link:"https://www.youtube.com/watch?v=u3v8d7EBHYk"
   },

   {
    title: "Ferramenta de desenvolvimento de Software low-code ",
    instructor: "Daiana Ribeiro",
    /*institution: "xx",
    desc: `xx`,*/
    certificado: "https://sites.pucgoias.edu.br/certificados/participantes/2868",
    date: "17/04",
    time: '10:30',
    place: 'Online',
    link:"https://www.youtube.com/watch?v=zQrZMSrmyhk"
   },

   {
    title: "Customer Experience and Artificial Intelligence",
    instructor: "Patrícia Amaral",
    /*institution: "xx",*/
    desc: `A experiência do cliente, enriquecida por jornadas bem desenhadas, serve como alavanca crucial para negócios ao criar interações personalizadas e memoráveis. Essa abordagem aumenta a satisfação e fidelidade, transformando clientes em defensores da marca, o que impulsiona a recompra e promove indicações, resultando em crescimento sustentável e maior rentabilidade. A IA está revolucionando a compreensão e interação com os dos clientes, tornando-a mais personalizada, eficiente e satisfatória. Entre novas tecnologias e modelos de negócios inovadores, vamos mergulhar
    neste mundo IA e CX.`,
    certificado: "https://sites.pucgoias.edu.br/certificados/participantes/2891",
    date: "18/04",
    time: '20:30',
    place: 'Online',
    link:"https://www.youtube.com/watch?v=JXmcZbQQOwk"
   },

   {
    title: "As tecnologias de reconhecimento de imagem assistindo à saúde com o planejamento neurocirúrgico ",
    instructor: "Wallace Souza Loos",
    /*institution: "xx",
    desc: `xx`,*/
    certificado: "https://sites.pucgoias.edu.br/certificados/participantes/2851",
    date: "12/04",
    time: '19:00',
    place: 'Online',
    link:"https://www.youtube.com/watch?v=Ic1lfAhEqNM"
   },

   {
    title: "Os efeitos dos microplásticos em sedimentos de lagos e rios europeus ",
    instructor: "Anne Louise de Melo Dores",
    /*institution: "xx",*/
    desc: ` Palestrante: Anne Louise de Melo Dores, Palestrante Egressa do Curso de Engenharia Civil, realiza atualmente mestrado na Universidade de Stuttgart, na Alemanha. Irá tratar do tema: Os efeitos dos microplásticos em sedimentos de lagos e rios europeus.`,
    certificado: "https://sites.pucgoias.edu.br/certificados/participantes/2899",
    date: "18/04",
    time: '09:00',
    place: 'Online',
    link:"https://www.youtube.com/watch?v=QklGnm2gDho"
   },

   {
    title: "Harvesting rare earth elements and critical minerals from coal derived acid mine drainage",
    instructor: "Dr. Iuri Santos",
    /*institution: "xx",*/
    desc: `Palestra: Harvesting rare earth elements and critical minerals from coal derived acid mine drainage.`,
    certificado: "https://sites.pucgoias.edu.br/certificados/participantes/2914",
    date: "19/04",
    time: '18:45',
    place: 'Online',
    link:"https://www.youtube.com/watch?v=BXj_MrAXvh4"
   },

   {
    title: "Por uma crítica da ecologia política: investigando a reprodução social da natureza",
    instructor: "Camilo Vladimir de Lima Amaral",
    /*institution: "xx",
    desc: `xx`,*/
    date: "18/04",
    time: '08:00',
    place: 'Online: Teams',
    link:"https://teams.microsoft.com/l/meetup-join/19%3adcb5856375ad4247a353459a1d1f6306%40thread.tacv2/1712675159930?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%2272de42cb-2066-4981-b6e6-af2344b756bd%22%7d"
   },

   {
    title: "Seleção e recrutamento de aeronáutas na Azul Linhas Aéreas",
    instructor: "Heitor Giuliano Matioli Candido",
    institution: "Azul Linhas Aéreas",
    desc: `Seleção e recrutamento de aeronáutas na Azul Linhas Aéreas`,
    date: "17/04",
    time: '20:00',
    place: 'Online: Teams',
    link:"https://teams.microsoft.com/l/meetup-join/19%3adcb5856375ad4247a353459a1d1f6306%40thread.tacv2/1713177106593?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%2272de42cb-2066-4981-b6e6-af2344b756bd%22%7d"
   },

   {
    title: "Aviação civil, mercado de trabalho, oportunidades",
    instructor: "Raoni Jacobson",
    /*institution: "xx",
    desc: `xx`,*/
    date: "15/04",
    time: '20:00',
    place: 'Online: Teams',
    link:"https://teams.microsoft.com/l/meetup-join/19%3adcb5856375ad4247a353459a1d1f6306%40thread.tacv2/1712673915601?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%2272de42cb-2066-4981-b6e6-af2344b756bd%22%7d"
   },

   {
    title: "Carreira até a Alemanha de aluno egresso da PUC Goiás",
    instructor: "Thalles Antônio de Urzedo Machado",
    /*institution: "xx",
    desc: `xx`,*/
    certificado: "https://sites.pucgoias.edu.br/certificados/participantes/2888",
    date: "17/04",
    time: '18:00',
    place: 'Online: Teams',
    link:"https://teams.microsoft.com/l/meetup-join/19%3adcb5856375ad4247a353459a1d1f6306%40thread.tacv2/1712675268758?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%2272de42cb-2066-4981-b6e6-af2344b756bd%22%7d"
   },
   /*Palestra Cancelada
   {
    title: "Da Engenharia Mecatrônica à carreira de desenvolvedor de jogos no Canadá ",
    instructor: "Lavio Fidélis",
    institution: "xx",
    desc: `xx`,
    date: "10/04",
    time: '21:00',
    place: 'Online: Teams',
    link:"https://teams.microsoft.com/l/meetup-join/19%3adcb5856375ad4247a353459a1d1f6306%40thread.tacv2/1712770197534?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%227de682ee-0988-4ec1-ac3f-7069dc850ab2%22%7d"
   },
   */

   {
    title: "Meteorologia operacional e sistemas sinóticos ",
    instructor: "Antônio Marcos Vianna Campos",
    /*institution: "xx",
    desc: `xx`,*/
    certificado: "https://sites.pucgoias.edu.br/certificados/participantes/2896",
    date: "18/04",
    time: '19:00',
    place: 'Online: Teams',
    link:"https://teams.microsoft.com/l/meetup-join/19%3adcb5856375ad4247a353459a1d1f6306%40thread.tacv2/1712675569968?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%2272de42cb-2066-4981-b6e6-af2344b756bd%22%7d"
   },

   {
    title: "Manejo da Irrigação ",
    instructor: "Fernando Rezende da Costa",
    institution: "Irriga Global/Nutrisolo",
    desc: `A irrigação é a tecnologia com maior potencial de contribuir para o aumento da segurança alimentar e ambiental, bem como para a redução da fome e da pobreza, além de gerar grande número de empregos. Ela traz benefícios importantes relacionados à produção de alimentos, à geração de empregos, ao desenvolvimento social e ao meio ambiente. É uma tecnologia fundamental em qualquer planejamento estratégico dos estados e regiões.`,
    certificado: "https://sites.pucgoias.edu.br/certificados/participantes/2895",
    date: "17/04",
    time: '19:00',
    place: 'Online: Teams',
    link:"https://teams.microsoft.com/l/meetup-join/19%3adcb5856375ad4247a353459a1d1f6306%40thread.tacv2/1712675704751?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%2272de42cb-2066-4981-b6e6-af2344b756bd%22%7d"
   },

   {
    title: "Métodos de projeto sustentável ",
    instructor: "Halina Veloso e Zárate",
    /*institution: "xx",*/
    desc: `Um panorama sobre a pesquisa de doutorado que investiga a integração de dados sobre carbono no processo de projeto de arquitetura, explorando métodos de projeto baseados em dados focados nos estágios iniciais do projeto. Esta pesquisa visa testar a transferibilidade de dados entre escalas de arquitetura e design urbano. Para isso, realiza uma investigação empírica com profissionais, adotando casos tangíveis e identificando os desafios e gargalos na interação entre dados de carbono incorporados, em escala de construção, e dados urbanos georreferenciados.`,
    date: "17/04",
    time: '08:00',
    place: 'Online: Teams',
    link:"https://teams.microsoft.com/l/meetup-join/19%3adcb5856375ad4247a353459a1d1f6306%40thread.tacv2/1712675896432?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%2272de42cb-2066-4981-b6e6-af2344b756bd%22%7d"
   },

   {
    title: "Trabalho Remoto Internacional: desafios e perspectivas",
    instructor: "Flavio Signorelli Mendes e Walter Berchez",
    /*institution: "xx",
    desc: `xx`,*/
    date: "19/04",
    time: '19:00',
    place: 'Online',
    link:"https://www.youtube.com/watch?v=7uB8vFgdhac"
   },

   /*
   {
    title: "IA no mercado profissional",
    instructor: "João Paulo Tavares",
    //institution: "xx",
    //desc: `xx`,
    date: "15/04",
    time: '20:30',
    place: 'Online',
    //link: ""
   },
  */
   {
    title: "Propriedade Intelectual e Desenvolvimento Sustentável: Construindo nosso futuro comum com inovação e criatividade",
    instructor: "Lara Guerreiro Pires",
    institution: "Instituto Nacional da Propriedade Industrial, INPI, Brasil",
    desc: `Propriedade Intelectual e Desenvolvimento Sustentável: Construindo nosso futuro comum com inovação e criatividade`,
    date: "22/04",
    time: "17:00-18:00",
    place: "Online: Teams",
    link: "https://teams.microsoft.com/l/meetup-join/19%3adcb5856375ad4247a353459a1d1f6306%40thread.tacv2/1712776179262?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%2272de42cb-2066-4981-b6e6-af2344b756bd%22%7d"
  },

]

const Palestras_Producao = [

]

const Palestras_Design = [

]

const Palestras_Caer = [

]

const Palestras_Mestrado = [



]



const Palestras_Agronomia = [

]


const Palestras_Civil = [

]

const Palestras_ArquiteturaUrbanismo = [


]

const Palestras_ControleAutomacao = [


]

const Palestras_IniciacaoCientifica = [

]


CienciaEmCasa = CienciaEmCasa.sort((a, b) => {
  if(a.date < b.date) return -1;
  if(a.date > b.date) return 1;
  if(a.time < b.time) return -1;
  if(a.time > b.time) return 1;
  if(a.title < b.title) return -1;
  if(a.title > b.title) return 1;
  return 0;
});

export const Palestras_Cursos = [

  {
    curso: 'Ciência da Computação',
    palestras: CienciaEmCasa,
  },
  /*
  {
    curso: 'Agronomia',
    palestras: Palestras_Agronomia,
  },
  {
    curso: 'Arquitetura e Urbanismo',
    palestras: Palestras_ArquiteturaUrbanismo,
  },
  {
    curso: 'Ciências Aeronáuticas',
    palestras: Palestras_Caer,
  },
  {
    curso: 'Civil',
    palestras: Palestras_Civil,
  },
  {
    curso: 'Engenharia de Controle e Automação',
    palestras: Palestras_ControleAutomacao,
  },   
  {
    curso: 'Engenharia de Produção',
    palestras: Palestras_Producao,
  }, 
  {
    curso: 'Design',
    palestras: Palestras_Design,
  },  
  {
    curso: 'Mestrado',
    palestras: Palestras_Mestrado,
  },
  {
    curso: 'Iniciação Ciêntifica',
    palestras: Palestras_IniciacaoCientifica,
  },
  */  
]
